import t from "./index603.js";
import { withInstall as o } from "./index604.js";
const r = o(t);
export {
  r as ElBadge,
  r as default
};
